import styled from 'styled-components'
import { bp, font } from 'lib/core/resources/helpers/styled'
import { BREAKPOINT } from 'app/sofia/resources/constants'

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  @media (max-width: ${BREAKPOINT.LG}) {
    width: 40%;
    margin-bottom: 30px;
  }

  @media (max-width: ${BREAKPOINT.MD}) {
    width: 35%;
    max-width: 180px;
    flex-grow: 1;
  }

  ${bp('sm')`
    width: 100%;
    text-align: center;
    max-width: unset;
  `}

  form {
    display: flex;
    align-items: center;
    justify-content: space-between;

    @media (max-width: ${BREAKPOINT.MD}) {
      flex-wrap: wrap;
    }

    ${bp('sm')`
      flex-direction: column;
    `}

    > div {
      width: 67%;
      padding: 0;

      @media (max-width: ${BREAKPOINT.LG}) {
        width: 74%;
      }

      @media (max-width: ${BREAKPOINT.MD}) {
        width: 100%;
      }

      ${bp('sm')`
        width: 100%;
      `}

      input {
        height: 45px;
      }
    }

    button {
      min-width: 122px;
      margin-left: 16px;
      text-transform: uppercase;
      font: ${font('default', 'bold', '14px/1.5')};

      @media (max-width: ${BREAKPOINT.MD}) {
        margin: 15px 0 0 0;
      }

      ${bp('sm')`
        margin-top: 20px;
      `}

      > div {
        padding: 11px 30px;
      }
    }
  }
`
